export const getColumns = ({
  t = (s) => s,
  options = {},
  view = '',
  sorter,
}) => {
  const type = {
    title: t('Type'),
    dataIndex: 'type',
    key: 'type',
    ellipsis: true,
    render: (val) => {
      const _val = (options?.category || []).find((v) => v.value === val);

      if (_val) {
        return _val.label;
      }

      return val;
    },
  };

  if (view === 'locations') {
    return [
      type,
      {
        title: t('Name'),
        dataIndex: 'locationName',
        key: 'locationName',
        sorter: () => 0 + 0,
        ellipsis: true,
        defaultSortOrder: sorter?.key === 'locationName' ? sorter.order : undefined,
        render: (v, all) => all.name,
      },
    ];
  }

  return [
    type,
    {
      title: t('Sub Category'),
      dataIndex: 'subCategory',
      key: 'subCategory',
      ellipsis: true,
      render: (val) => {
        const _val = (options?.subCategory || []).find((v) => v.value === val);

        if (_val) {
          return _val.label;
        }

        return val;
      },
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      sorter: () => 0 + 0,
      ellipsis: true,
      defaultSortOrder: sorter?.key === 'name' ? sorter.order : undefined,
    },
  ];
};
